module.exports = require("lodash/snakeCase");